import { useMemo } from 'react';

import PellaDataGrid from '../DataGrid';
import { DataGridTableId } from '../../../utils/common';
import styles from './MoveOrderItemsListing.module.css';

/**
 * MoveOrderItemsListing component displays the current move order transactions in a data grid.
 * @param {object} props - Component props
 * @returns {import('react').ReactElement} The MoveOrderItemsListing component
 */
const MoveOrderItemsListing = (props) => {
  const tableData = useMemo(() => DataGridTableId(props.moveOrderItemsList), [props.moveOrderItemsList]);

  const moveOrderItemTables = {
    moveOrderTransactions: [
      { headerName: 'Item', field: 'item', editable: false },
      { headerName: 'Description', field: 'itemDescription', editable: false },
      { headerName: 'UOM', field: 'transactionUom', editable: false },
      { headerName: 'Qty', field: 'transactionQuantity', editable: true },
      {
        headerName: 'Status',
        field: 'result',
        render: (rowData) => {
          if (rowData.result === '') {
            return <span className={styles.statusNew}>New</span>;
          } else if (rowData.result === 200) {
            return <span className={styles.statusNew}>Okay</span>;
          }
          return <span className={styles.statusError}>Error</span>;
        },
        editable: false,
      },
    ],
  };

  ///////////////////////////////////////////////////////////////////////////////////

  const editable = {
    onRowUpdate: (_newValue, _oldValue, _rowData, _columnDef) => {
      props.updateRecord(_newValue, _oldValue);
      return Promise.resolve(true);
    },
    onRowDelete: (oldValue, _rowData, _columnDef) => {
      props.deleteRecord(oldValue, _rowData);
      return Promise.resolve(true);
    },
  };

  return (
    <div className={styles.root}>
      {tableData?.length > 0 ? (
        <div className={`${styles.topMargin} ${styles.bottomMargin}`}>
          <PellaDataGrid
            copy={false}
            title='Current Move Order Items'
            density='compact'
            pageSize={5}
            columns={moveOrderItemTables.moveOrderTransactions}
            rows={tableData}
            editable={editable}
          />
        </div>
      ) : (
        <span>No transactions currently added!</span>
      )}
    </div>
  );
};
export default MoveOrderItemsListing;
